import React from 'react'
import Link from 'next/link'
import styled from '@emotion/styled'
import { gsColors as c } from '../../styles/Variables'
import { LinkButton } from '../../styles/Components'
import { mq } from '../../helpers'

const CtaWrapper = styled.div`
  background-color: ${c.khaki};
  padding: 40px 24px;
  margin: 40px 0;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;

  ${mq('max', '800px')} {
    padding: 32px 16px;
    margin: 32px 0;
  }

  .cta-heading {
    font-family: Garnett;
    font-size: 24px;
    font-weight: 750;
    color: ${c.black};
    margin: 0;
    line-height: 140%;

    ${mq('max', '800px')} {
      font-size: 20px;
    }
  }
`

/** Render the article booking CTA with an accessible navigation target. */
export default function BlogCta() {
  return (
    <CtaWrapper>
      <p className="cta-heading">Ready to book your next appointment?</p>
      <Link href="/book" legacyBehavior passHref>
        <LinkButton>Book Now</LinkButton>
      </Link>
    </CtaWrapper>
  )
}
